import { useFeature } from '../feature'

export const useConversationFeature = (): ReturnType<typeof useFeature> => {
  return useFeature({
    featureId: 'Feature:RecordedConversations',
    placeholder: false,
  })
}
